import { render, staticRenderFns } from "./subNews.vue?vue&type=template&id=cb034592&scoped=true&"
import script from "./subNews.vue?vue&type=script&lang=js&"
export * from "./subNews.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./subNews.vue?vue&type=style&index=1&id=cb034592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb034592",
  null
  
)

export default component.exports